import { defineComponent as t } from "vue";
import p from "./td-longtail-vue-components3.js";
const s = /* @__PURE__ */ t({
  __name: "play-pause-button",
  props: {
    value: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    primary: { type: Boolean },
    secondary: { type: Boolean }
  },
  emits: ["input"],
  setup(n, { emit: e }) {
    const o = n;
    return { __sfc: !0, props: o, emit: e, handleClick: () => {
      e("input", !o.value);
    }, LinkButton: p };
  }
});
export {
  s as default
};
